import { HTMLAttributes as OriginalHTMLAttributes } from '@types/react';

/**
 * Расширяем global windows, чтобы можно было обращаться к window.bloko
 */
declare global {
    interface Window {
        bloko?: Partial<Record<string, unknown>>;
    }
}

/**
 * Расширяем список атрибутов HTML-элементов которые мы используем
 */
declare module '@types/react' {
    export interface HTMLAttributes extends OriginalHTMLAttributes {
        /** Указывает на строку с компонентом в исходном коде в режиме разработки. Генерируется babel-plugin-react-source */
        source?: string;
        /** data-qa элемента, используется для тестов */
        'data-qa'?: string;
    }
}
